import { o as u } from "./ownerDocument-CUrv0DIK.mjs";
function a(o, t = 166) {
  let e;
  function n(...c) {
    const r = () => {
      o.apply(this, c);
    };
    clearTimeout(e), e = setTimeout(r, t);
  }
  return n.clear = () => {
    clearTimeout(e);
  }, n;
}
function d(o) {
  return u(o).defaultView || window;
}
export {
  a as d,
  d as o
};
//# sourceMappingURL=ownerWindow-CJokPycY.mjs.map
